<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        class="base-input"
        :outlined="outlined"
        :value="value"
        :solo="!outlined"
        :flat="!outlined"
        readonly
        :height="height"
        dense
        v-on="on"
        @focus="outlined = true"
        @blur="outlined = false"
      >
        <template v-slot:append>
          <img src="../../assets/time.svg" />
        </template>
      </v-text-field>
    </template>
    <v-time-picker full-width :value="value" @change="onChange"></v-time-picker>
  </v-menu>
</template>
<script>
export default {
  name: "TimePicker",
  props: {
    value: String,
    fieldName: { default: "", type: String },
    height: { default: 47, type: Number },
  },
  data: () => ({
    menu: false,
    outlined: false,
  }),
  methods: {
    onChange(value) {
      this.menu = false;
      this.$emit("change", value, this.fieldName);
    },
  },
};
</script>
